import { Brand, Universe, UsageNameToCodeEnum } from '@ecm/portfolio';

import { Link } from '../link/link';

export enum DeepLinkType {
    CONTRACT = 'CONTRACT',
    USAGE = 'USAGE',
    NONE = 'NONE',
}

export enum ContractState {
    IN_CREATION = 'en creation',
    ACTIVE = 'actif',
    RESILIED = 'resilie',
    CLOSED = 'clos',
}

export enum ContractCategory {
    TELCO = 'telco',
    SECURITY = 'security',
}

export enum MarketType {
    GENERIC = 'generic',
    RES = 'res',
}

export interface ContractFilter {
    brand?: Brand;
    state?: ContractState;
    types?: [Universe];
    vertical?: ContractCategory;
    marketTypes?: [MarketType];
}

export enum SelectTab {
    HOME = 'HOME',
    SHOP = 'SHOP',
    HELP = 'HELP',
    ACCOUNT = 'ACCOUNT',
    NOTIF = 'NOTIF',
}

export enum ChannelType {
    MOBILE = 'MOBILE',
    WEB = 'WEB',
}

export interface UsageFilter {
    usageTypes?: UsageNameToCodeEnum[];
}

export class DeepLink {
    public linkType: DeepLinkType;
    public contractFilter?: ContractFilter;
    public usageFilter?: UsageFilter;
    public fallbackLink?: Link;
    public link: Link;
    public selectedTab?: SelectTab;
    public title?: string;
    public channel?: ChannelType;

    public constructor(init?: Partial<DeepLink>) {
        Object.assign(this, init);
    }
}
